// components/tenantPaymentSettings/TenantPaymentSettingsList.tsx
import React, { useEffect, useState } from "react";
import { ResponseTenantPaymentSettingsDto } from "../../types/tenantPaymentSettings.types";
import { useDispatch } from "react-redux";
import { Card } from "../ui/Card";
import { getAllTenantPaymentSettings } from "../../service/tenantPaymentSettings/TenantPaymentSettingsService";
import { Button } from "../ui/Button";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface TenantPaymentSettingsListProps {
  onEdit: (id: number) => void;
  onRefresh: () => void;
  refreshTrigger: number;
  createNew: () => void;
}

export function TenantPaymentSettingsList({
  onEdit,
  onRefresh,
  refreshTrigger,
  createNew,
}: TenantPaymentSettingsListProps) {
  const dispatch = useDispatch();
  const [settings, setSettings] = useState<ResponseTenantPaymentSettingsDto[]>(
    []
  );

  useEffect(() => {
    loadSettings();
  }, [refreshTrigger]);

  const loadSettings = async () => {
    const result = await getAllTenantPaymentSettings(dispatch);
    if (result) {
      setSettings(result);
    }
  };


  const maskSecret = (_secret?: string) => {
    return "****";
  };


  return (
    <Card className="card_content_padding card_custonized">
      <div className="border border-solid border-gray-200 dark:border-dark-border rounded-lg overflow-auto">
        <div className="flex justify-between items-center flex-wrap bg-[#f9fafb] dark:bg-dark-surface p-4 rounded-t-lg">
          <h2 className="text-lg font-bold surface-900 dark:text-white mt-0 mb-0">
            Payment Settings
          </h2>
          <div className="flex gap-3">
            {settings.length < 1 && (
              <Button variant="primary" onClick={createNew}>
                Create
              </Button>
            )}
            <Button variant="primary" onClick={onRefresh}>
              Refresh
            </Button>
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200 dark:divide-dark-border">
            <thead className="bg-gray-100 dark:bg-dark-bg">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                  ID
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                  Tenant ID
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                  Secret Key
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                  Webhook Secret
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                  Created Date
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white dark:bg-dark-surface text-gray-900 dark:text-gray-200 divide-y divide-gray-200 dark:divide-dark-border">
              {settings.length > 0 ? (
                settings.map((setting) => (
                  <tr
                    key={setting.id}
                    className="hover:bg-primary-light hover:bg-opacity-10 dark:hover:bg-white dark:hover:bg-opacity-5"
                  >
                    <td className="px-4 py-3 whitespace-nowrap">
                      {setting.id}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      {setting.tenant_id === null ? "Host" : setting.tenant_id}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap font-mono">
                      {maskSecret(setting.secret_key)}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap font-mono">
                      {maskSecret(setting.webhook_secret)}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      {new Date(setting.createdAt).toLocaleDateString()}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      <Button
                        className="actionBtn mr-2 bg-transparent text-gold hover:text-white border-gold hover:bg-gold hover:border-gold"
                        children={<FontAwesomeIcon icon={faPen} />}
                        onClick={() => onEdit(setting.id)}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={6}
                    className="px-4 py-3 text-center text-gray-500 dark:text-gray-400"
                  >
                    No payment settings found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </Card>
  );
}
